import axios, { AxiosResponse } from "axios";
import * as Cookies from "js-cookie";
import { TrackingDetailModel } from "../models/tracking-detail-model";

interface IEmosObject {
	[key: string]: any
}

const list: NodeListOf<HTMLElement> = document.querySelectorAll(".seminarSearchTracking");
const bookButtons: NodeListOf<HTMLElement> = document.querySelectorAll(".cart__btn");

export const TrackingSearch = (): void => {
	if (list.length > 0) {
		list.forEach(trigger => {
			trigger.addEventListener("click", TrackingSearchFunction);
		});
	}
};



export const TrackingCheckout = (): void => {
	const order = JSON.parse(localStorage.getItem("thankyouCart"))
	if (order != null) {
		order.data.Order.LineItems.forEach(function(product: any) {
            const data = {
				EventName: "checkout",
				ProductId: product.Product.ProductId,
				Price: Number((product.SingleItemNetPrice.Amount/ 100)).toFixed(2),
				Count: product.Quantity,
                SessionId: getFactFinderSessionId()
			}
            axios.post<TrackingDetailModel>(`/umbraco/api/FactFinderTracking/CartTracking`, data)
            .then((result: AxiosResponse) => {
            })
            .catch((error: any) => {
                if (error?.response?.data) {
                    console.log(error?.response?.data);
                }
            })
		})
    }
};

export const TrackingCart = (): void => {
	bookButtons.forEach(function (button) {
		button.addEventListener("click", TrackingCartFunction);
	});
}


function TrackingSearchFunction(this: HTMLElement): void {

    const data = {
        ProductID: this.getAttribute("data-productid"),
        Query: this.getAttribute("data-query"),
        Position: this.getAttribute("data-position"),
        OrigPosition: this.getAttribute("data-origposition"),
        Page: this.getAttribute("data-page"),
        PageSize: this.getAttribute("data-pagesize"),
        OrigPageSize: this.getAttribute("data-origpagesize"),
        FactFinderCampaign: this.getAttribute("data-factfindercampaign"),
        SessionId: getFactFinderSessionId()
    }
    if (!data.Query || data.Query.length === 0) {
        return;
    }

    axios.post<TrackingDetailModel>(`/umbraco/api/FactFinderTracking/SearchTracking`, data)
    .then((result: AxiosResponse) => {
    })
    .catch((error: any) => {
        if (error?.response?.data) {
            console.log(error?.response?.data);
        }
    })
}

function getFactFinderSessionId(): string {
    let sessionId = Cookies.get("ffSessionId");
    if (!sessionId) {
        sessionId = crypto.randomUUID();
        Cookies.set("ffSessionId", sessionId);
    }
    return sessionId;
}

function TrackingCartFunction(this: HTMLElement){
    const data = {
        ProductId: this.getAttribute("data-productid"),
        EventName: "cart",
        Price: Number(this.getAttribute("data-price")).toFixed(2),
        Count: 1,
        SessionId: getFactFinderSessionId()
    }
    axios.post<TrackingDetailModel>(`/umbraco/api/FactFinderTracking/CartTracking`, data)
    .then((result: AxiosResponse) => {
    })
    .catch((error: any) => {
        if (error?.response?.data) {
            console.log(error?.response?.data);
        }
    })
}
